import React from 'react';
import { number, string, oneOf } from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import { LoaderWrapper, IconWrapper, IconWrapperSmall } from './ActivityProgress.styles';
import { Colors, Icons } from '../..';
const BASE_SIZE = 56;
const ProgressInfiniteIcon = Icons.progressInfinite;
const IncompleteIcon = Icons.incomplete;
const CompleteIcon = Icons.complete;
const {
  plum_electric,
  plum_electric_active
} = Colors;
const getIcon = iconName => {
  switch (iconName) {
    case 'progress':
      return /*#__PURE__*/React.createElement(ProgressInfiniteIcon, {
        "data-test-id": "progress-icon"
      });
    case 'incomplete':
      return /*#__PURE__*/React.createElement(IncompleteIcon, {
        "data-test-id": "incomplete-icon"
      });
    case 'complete':
      return /*#__PURE__*/React.createElement(CompleteIcon, {
        "data-test-id": "complete-icon"
      });
    case 'none':
    default:
      return null;
  }
};
export const ActivityProgress = _ref => {
  let {
    progressIndicatorColor,
    progressIndicatorCircleColor,
    progress,
    icon,
    size
  } = _ref;
  const divider = size === 'large' ? 1 : 3.5;
  const outerSize = BASE_SIZE / divider;
  const innerSize = BASE_SIZE / divider;
  return /*#__PURE__*/React.createElement(LoaderWrapper, {
    outerSize: outerSize
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    variant: "determinate",
    value: 100,
    size: outerSize,
    thickness: 1.5,
    color: "secondary",
    style: {
      color: progressIndicatorCircleColor
    }
  }), /*#__PURE__*/React.createElement(CircularProgress, {
    variant: "determinate",
    value: progress > 100 ? 100 : progress,
    size: innerSize,
    thickness: 1.5,
    style: {
      color: progressIndicatorColor
    }
  }), size === 'small' ? /*#__PURE__*/React.createElement(IconWrapperSmall, {
    "data-test-id": "icon-wrapper",
    outerSize: outerSize,
    className: "".concat(icon)
  }, getIcon(icon)) : /*#__PURE__*/React.createElement(IconWrapper, {
    "data-test-id": "icon-wrapper",
    outerSize: outerSize,
    className: "".concat(icon)
  }, getIcon(icon)));
};
ActivityProgress.propTypes = {
  progressIndicatorColor: string,
  progressIndicatorCircleColor: string,
  progress: number,
  icon: oneOf(['progress', 'incomplete', 'complete', 'none']),
  size: oneOf(['small', 'large'])
};
ActivityProgress.defaultProps = {
  progressIndicatorColor: plum_electric,
  progressIndicatorCircleColor: plum_electric_active,
  progress: 0,
  icon: 'none',
  size: 'large'
};